import React, { FC } from 'react';
import { Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type ChipLabelProps = {
    label: string;
    onDelete: () => void;
};

const chipStylesBase = {
    backgroundColor: '#75CACB1A',
    border: '1px solid #75CACB',
    borderRadius: '6px',
    fontSize: '16px',
    lineHeight: '24px',
    maxWidth: '600px',
    height: 'auto',
    '& .MuiChip-label': {
        display: 'block',
        whiteSpace: 'normal'
    }
};

export const ChipLabel: FC<ChipLabelProps> = ({ label, onDelete }) => {
    return (
        <Chip variant={'outlined'} deleteIcon={<CloseIcon />} sx={chipStylesBase} label={label} onDelete={onDelete} />
    );
};
